import getPriceBillingConfig from './getPriceBillingConfig';

/**
 * Whether a price is a payment PLAN (a recurring price that stops after a fixed
 * number of payments) rather than an open-ended subscription.
 *
 * Gates `?<reference>_no_of_payments`: on a multi-price product the merchant
 * picks the billing shape per price, so the URL may only adjust the length of a
 * plan that is already a plan — it must never turn a subscription into one.
 */
export default function isPaymentPlanPrice(price) {
  if (price?.billingType !== 'recurring') return false;
  return Number(getPriceBillingConfig(price)?.planIterations) > 0;
}
